import { Component, ChangeDetectionStrategy, effect, signal } from '@angular/core';
import { NgIf } from '@angular/common';
import { TabViewModule } from 'primeng/tabview';
import { MyProfileAccountsComponent } from './sections/accounts/my-profile-accounts.component';
import { MyProfileSecurityComponent } from './sections/security/my-profile-security.component';
import { MyProfileNotificationsComponent } from './sections/notifications/my-profile-notifications.component';

@Component({
   selector: 'app-my-profile',
   standalone: true,
   imports: [
      NgIf,
      TabViewModule,
      MyProfileAccountsComponent,
      MyProfileSecurityComponent,
      MyProfileNotificationsComponent
   ],
   templateUrl: './my-profile.component.html',
   styleUrls: ['./my-profile.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyProfileComponent {
   activeIndex = signal<number>(Number(localStorage.getItem('myProfile.tab') ?? 0));

   // persist tab between visits
   private _persist = effect(() => {
      localStorage.setItem('myProfile.tab', String(this.activeIndex()));
   });
}
